import * as React from 'react';
/**
 * Хук useLayoutEffect без вонингов на стороне сервера
 */

export var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;